/* eslint-disable no-undef */
import { Bouncer } from "/Assets/libs/bouncer-es6.js";
import { getTranslations } from "/Assets/js/common/translations.js";

// Initialize the class only if any data-login-form attributes are found
document.addEventListener("DOMContentLoaded", async () => {
    if (document.querySelectorAll("[data-login-form]").length > 0) {
        const siteLogin = new SiteLogin();
        await siteLogin.init();
    }
});

class SiteLogin {
    constructor() {
        this.forms = [];
        this.bouncers = new Map();
        this.translations = null;
    }

    async init() {
        this.translations = await getTranslations();

        // Find all login forms in the document
        const loginForms = document.querySelectorAll("[data-login-form]");

        loginForms.forEach(form => {
            this.forms.push(form);
            this.setupFormValidation(form);
            this.bindEvents(form);
        });
    }

    bindEvents(form) {
        const submitButton = form.querySelector("button[name=submitBtn], button[type=submit], input[type=submit]");
        if (submitButton) {
            submitButton.addEventListener("click", (e) => this.handleSubmit(e, form));
        }
    }

    handleSubmit(e, form) {
        e.preventDefault();
        e.stopPropagation();

        const bouncer = this.bouncers.get(form);
        if (!bouncer) return;

        const invalidFields = bouncer.validateAll();
        const isValid = invalidFields.length === 0;

        if (isValid) {
            this.showLoadingState(form);
            form.submit();
        }
    }

    setupFormValidation(form) {
        const t = this.translations.JsResources.Translations.Common;
        const bouncer = new Bouncer(form, {
            disableSubmit: true,
            messages: {
                missingValue: {
                    default: t.ThisFieldRequired
                },
                patternMismatch: {
                    default: t.ThisFieldRequired
                }
            }
        });

        this.bouncers.set(form, bouncer);
    }

    showLoadingState(form) {
        const submitBtn = form.querySelector(".btn-primary");
        if (!submitBtn) return;

        const loadingText = submitBtn.getAttribute("data-loading-text");
        if (loadingText) {
            submitBtn.setAttribute("data-label-text", submitBtn.innerHTML);
            submitBtn.innerHTML = loadingText;
        }
    }
}